
import type { Conversation } from "#types/types.ts";
import { useMemo } from "react";

const now = new Date();

const startOfThisWeek = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - now.getUTCDay() + 1)); // Start on Monday
const startOfLastWeek = new Date(startOfThisWeek);
startOfLastWeek.setUTCDate(startOfThisWeek.getUTCDate() - 7);
const startOfTwoWeeksAgo = new Date(startOfLastWeek);
startOfTwoWeeksAgo.setUTCDate(startOfLastWeek.getUTCDate() - 7);

export const useCategorizedConversations = (conversations: Conversation[]) => {
    const categorizedConversations = useMemo(() => {
        const thisWeekConversations: Conversation[] = [];
        const lastWeekConversations: Conversation[] = [];
        const olderConversations: Conversation[] = [];

        conversations.forEach(conversation => {
            const updatedDate = new Date(conversation.updatedAt);

            if (updatedDate >= startOfThisWeek) {
                thisWeekConversations.push(conversation);
            } else if (updatedDate >= startOfLastWeek) {
                lastWeekConversations.push(conversation);
            } else {
                olderConversations.push(conversation);
            }
        });

        const sortByUpdatedAtDesc = (a: Conversation, b: Conversation) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();

        thisWeekConversations.sort(sortByUpdatedAtDesc);
        lastWeekConversations.sort(sortByUpdatedAtDesc);
        olderConversations.sort(sortByUpdatedAtDesc);

        return {
            thisWeekConversations,
            lastWeekConversations,
            olderConversations
        };
    }, [conversations]);

    return categorizedConversations;
};
